import React, { useEffect, useState } from "react";
import { CheckCircle2, ExternalLink, AlertCircle } from "lucide-react";
import { api } from "../lib/api";

export default function AssessmentCard({ user, onVerified }) {
  const verified = !!user?.assessment_completion_code;
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (verified) {
    return (
      <div className="bg-[#10B981]/10 border border-[#10B981]/40 px-5 py-3 inline-flex items-center gap-3 rounded-sm" data-testid="assessment-verified-pill">
        <CheckCircle2 className="text-[#10B981] flex-shrink-0" size={18} />
        <p className="text-gray-800 text-sm">
          <span className="font-bold">Assessment Verified</span>
          <span className="text-gray-500"> · code </span>
          <span className="font-mono">{user.assessment_completion_code}</span>
          {user.assessment_completed_at && (
            <span className="text-gray-500"> · {new Date(user.assessment_completed_at).toLocaleDateString()}</span>
          )}
        </p>
      </div>
    );
  }

  const onVerify = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const r = await api.post("/assessment/verify-code", { completion_code: code });
      onVerified?.(r.data);
    } catch (err) {
      console.error("Assessment verify failed", err);
      setError(err.response?.data?.detail || "Could not verify code");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white border border-fc-red/40 p-6 sm:p-8" data-testid="assessment-card">
      <div className="grid lg:grid-cols-[1fr_auto] gap-6 items-start lg:items-center">
        <div className="max-w-2xl">
          <p className="fc-overline mb-2 text-[10px]">FREDDY INTEL · STEP 1</p>
          <h2 className="text-2xl sm:text-3xl font-black tracking-tight mb-3">
            Complete your AI Readiness Assessment
          </h2>
          <p className="text-gray-500 text-sm sm:text-base leading-relaxed">
            Take the Freddy Intel assessment at{" "}
            <span className="text-fc-red font-bold">intel.freddycmpute.com</span>, then paste your completion code below.
          </p>
        </div>
        <a
          href="https://intel.freddycmpute.com"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-fc-red whitespace-nowrap"
          data-testid="assessment-open-intel"
        >
          Open Freddy Intel <ExternalLink size={14} />
        </a>
      </div>

      <form onSubmit={onVerify} className="mt-6 flex flex-col sm:flex-row gap-3" data-testid="assessment-verify-form">
        <input
          type="text"
          required
          placeholder="Paste your completion code (e.g. INT-ABC-123)"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="flex-1 bg-white border border-gray-200 focus:border-fc-red text-white px-4 py-3 outline-none transition-colors font-mono text-sm"
          data-testid="assessment-code-input"
        />
        <button type="submit" disabled={busy || !code.trim()} className="btn-fc-outline justify-center" data-testid="assessment-verify-btn">
          {busy ? "Verifying…" : "Verify"}
        </button>
      </form>
      {error && (
        <p className="mt-3 text-fc-red text-sm flex items-center gap-2"><AlertCircle size={14} /> {error}</p>
      )}
    </div>
  );
}
